import React from 'react';
import { Typography } from '@mui/material';
import BuildInfo from './buildinfo.json';
const VersionPage = () => {
  return <Typography>{`Version ${BuildInfo.date} build ${BuildInfo.build}`}</Typography>;
};
export default VersionPage;
